import React from 'react';
import styled from 'styled-components';

import { LiveMeetingAttendanceConfirmationStatusEnum } from 'app/types/cards/LiveVideoCard';
import { createUrl, stripTags } from 'app/utils';
import { Box, ButtonIcon, ConditionalLink, Flex, Typography } from 'components';
import { ProductContentLiveMeetingItemResponse } from 'features/products';
import { formatDateFromUtcToTimezone } from 'app/utils/formatDateFromUtcToTimezone';

const LessonBullet = styled('i')`
  background: ${({ theme }) => theme.colors.gray_100};
  position: absolute;
  z-index: 5;
  width: 12px;
  height: 22px;
  border-radius: 11px;
  top: 12px;
  left: 15px;

  &::before {
    content: '';
    border-radius: 50%;
    border: 2px solid ${(props: any) => (props['data-active'] ? props.theme.colors.primary_400 : props.theme.colors.gray_300)};
    background: ${(props: any) => (props['data-active'] ? props.theme.colors.primary_400 : 'transparent')};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
  }
`;

const FlexBorder = styled(Flex)``;

const CustomConditionalLink = styled(ConditionalLink)`
  display: flex;
  position: relative;

  &::before {
    content: '';
    display: block;
    width: 2px;
    height: 100%;
    background: ${({ theme }) => theme.colors.gray_300};
    position: absolute;
    top: 0;
    left: 20px;
  }

  ${FlexBorder} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray_200};
  }

  &:last-child {
    border-radius: 4px;

    ${FlexBorder} {
      border-bottom: 0;
    }

    &:before {
      height: 50%;
    }
  }

  &:hover {
    background: ${({ theme }) => theme.colors.gray_200};

    ${LessonBullet} {
      background: ${({ theme }) => theme.colors.gray_200};
    }
  }
`;

interface ProductsEvolutionLiveCardProps {
  index: number;
  live: ProductContentLiveMeetingItemResponse;
}

const ProductsEvolutionLiveCard = ({ live, index }: ProductsEvolutionLiveCardProps) => {
  return (
    <CustomConditionalLink
      key={`content-${live.uuid}-${index.toString()}`}
      to={(live.uuid && createUrl('liveConfirmation', [live.uuid])) || ''}
      type={Boolean(live.uuid) ? 'external' : 'nolink'}
      component={Flex}
      target="_blank"
    >
      <Flex flexWrap="nowrap" alignItems="flex-start" position="relative" pl={40}>
        <FlexBorder py={3}>
          <LessonBullet data-active={live.attendanceConfirmationStatus === LiveMeetingAttendanceConfirmationStatusEnum.Confirmed} />

          <Flex flexWrap="nowrap">
            <Flex pr={3}>
              <Typography type="type1" fontWeight="bold" color={'gray_600'}>
                {stripTags(live.name)}
              </Typography>
            </Flex>
          </Flex>
        </FlexBorder>
      </Flex>

      <FlexBorder flexGrow={0} pr={30} alignItems="center" flexWrap="nowrap">
        <Box display={{ m: 'none', d: 'inline' }} mr="10px">
          {Boolean(live.date) && (
            <Typography type="type0" color="gray_500" style={{ whiteSpace: 'nowrap' }}>
              {formatDateFromUtcToTimezone(live.date).format('DD/MM/YYYY hh:mm')}
            </Typography>
          )}
        </Box>

        <ButtonIcon
          icon="play"
          width={{ m: 20 }}
          height={{ m: 20 }}
          bg="transparent"
          color={
            !live.isBlocked
              ? live.attendanceConfirmationStatus === LiveMeetingAttendanceConfirmationStatusEnum.Confirmed
                ? 'primary_400'
                : 'black30'
              : 'black30'
          }
          title="Assistir Vídeo"
        />
      </FlexBorder>
    </CustomConditionalLink>
  );
};

export default ProductsEvolutionLiveCard;
